import $ from "jquery";
import debounce from "lodash-es/debounce";

import { store } from "common/store";

const afterElement = window.getComputedStyle(document.body, ":after");

const updateBreakpointValue = function() {
    // Some browsers return the content wrapped in double quotes.
    // Chrome 43 wraps in single quotes
    const rawVal = afterElement ? afterElement.getPropertyValue("content") : "";
    
    store.dispatch({
        type: "config/SET_MEDIA_QUERY_BREAKPOINT",
        value: rawVal.replace(/["']/g, "")
    });
};

export const listenForMediaQueryChange = function() {
    $(window).on("resize.mq orientationchange.mq load.mq", debounce(updateBreakpointValue, 100));
    updateBreakpointValue();
};

export const stopListeningForMediaQueryChange = function() {
    $(window).off("resize.mq orientationchange.mq load.mq");
};
